import Cookies from 'js-cookie';
import monitor from '@baidu/fe-monitor';
import {Channel, LoginType} from '@/constants';
import {sessionRemove} from '@/service';
import {passportThirdLoginSuccess} from './pc-init';

export function bindPASSEvent(options: any, channel: Channel) {
    // 点击百度账号Tab
    $('.passport-tab-btn').on('click', () => {
        const defaultPassLoginType = Cookies.get('default_pass_login_type') || LoginType.SMS_PASSPORT;
        Cookies.set('default_ui_login_type', defaultPassLoginType, {expires: 7});
        if (defaultPassLoginType === LoginType.SMS_PASSPORT) {
            // http://passport.qatest.baidu.com/passApi/js/loginv5_tangram_4468608.js
            // passport sdk 内部方法，谨慎使用
            options.target._changeLoginType('sms');
            monitor.trackBehavior({
                name: `百度智能云控制台-login-${channel}登录页-默认登录方式`,
                category: '默认登录方式',
                action: 'click',
                value: 'passport-sms-tab',
            });
        } else {
            monitor.trackBehavior({
                name: `百度智能云控制台-login-${channel}登录页-默认登录方式`,
                category: '默认登录方式',
                action: 'click',
                value: 'passport-normal-tab',
            });
        }
        monitor.trackBehavior({
            name: `百度智能云控制台-login-${channel}登录页-登录方式切换`,
            category: '登录方式切换',
            action: 'click',
            value: 'passport-tab',
        });
    });

    // 点击账号登录
    $('#TANGRAM__PSP_4__changePwdCodeItem').on('click', () => {
        Cookies.set('default_ui_login_type', LoginType.NORMAL_PASSPORT, {expires: 7});
        Cookies.set('default_pass_login_type', LoginType.NORMAL_PASSPORT, {expires: 7});
        if (channel === 'wap') {
            $('.pass-foot-bar-forget-wrap').css('visibility', 'visible');
        }
        monitor.trackBehavior({
            name: `百度智能云控制台-login-${channel}登录页-登录方式切换`,
            category: '登录方式切换',
            action: 'click',
            value: 'passport-normal-tab',
        });
    });
    // 点击手机号登录
    $('#TANGRAM__PSP_4__changeSmsCodeItem').on('click', () => {
        Cookies.set('default_ui_login_type', LoginType.SMS_PASSPORT, {expires: 7});
        Cookies.set('default_pass_login_type', LoginType.SMS_PASSPORT, {expires: 7});
        _hmt.push(['_trackEvent', 'switch_login_type', 'sms', channel]);
        if (channel === 'wap') {
            $('.pass-foot-bar-forget-wrap').css('visibility', 'hidden');
        }
        monitor.trackBehavior({
            name: `百度智能云控制台-login-${channel}登录页-登录方式切换`,
            category: '登录方式切换',
            action: 'click',
            value: 'passport-sms-tab',
        });
    });
    $('.pass-button-submit').on('click', async () => {
        _hmt.push(['_trackEvent', 'login', 'passport', channel]);
        await sessionRemove();
    });

    $('.pass-reglink').on('click', () => {
        _hmt.push(['_trackEvent', 'reg', 'passport', channel]);
    });

    // 三方登录
    window.addEventListener(
        'message',
        event => {
            if (event?.data?.type === 'thirdlogin') {
                // 注意，登录成功后的跳转需要业务方自己跳转
                const data = event?.data?.data || {};
                passportThirdLoginSuccess(data);
            }
        },
        false
    );

    $('.pass-text-input-userName').attr('placeholder', '请输入手机号/用户名/邮箱');
    $('.pass-text-input-password').attr('placeholder', '请输入密码');
    $('#pass-login.tang-pass-login .pass-form-item .pass-text-input-smsPhone').attr('placeholder', '请输入手机号');
    $('#pass-login.tang-pass-login .pass-form-item .pass-text-input-smsVerifyCode').attr('placeholder', '短信验证码');
}

export function bindUCEvent(channel: Channel) {
    // 点击云账号Tab
    $('.uc-tab-btn').on('click', () => {
        Cookies.set('default_ui_login_type', LoginType.UC, {expires: 7});
        monitor.trackBehavior({
            name: `百度智能云控制台-login-${channel}登录页-登录方式切换`,
            category: '登录方式切换',
            action: 'click',
            value: 'uc-tab',
        });
    });
    $('#submit-form').on('click', async () => {
        // uc sdk 没有清除上一次的错误提示
        $('#account-error').html('');
        $('#password-error').html('');
        _hmt.push(['_trackEvent', 'login', 'uc', channel]);
        await sessionRemove();
    });
    $('.uc-register').on('click', () => {
        _hmt.push(['_trackEvent', 'reg', 'uc', channel]);
    });
}
